export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[60vh] gap-4 text-center p-8">
      <p className="text-6xl font-bold text-muted-foreground/30">404</p>
      <h2 className="text-xl font-semibold text-foreground">Page introuvable</h2>
      <p className="text-muted-foreground text-sm">Cette page n'existe pas dans l'espace partenaire.</p>
      <a href="/" className="text-primary text-sm hover:underline">← Retour au tableau de bord</a>
    </div>
  );
}
